import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BulkAccessConfirmPhase } from '../bulk-access.models';

/**
 * DOVE-2626 — count-and-scope confirmation shared by bulk Remove and large-batch Add. A plain
 * p-dialog (appended to body) rather than ConfirmationService, so it can't be answered by some
 * other keyless <p-confirmDialog> on the page and can stack over the Add dialog.
 *
 * DOVE-2676 — also hosts the undo countdown. It can never be dismissed by clicking outside; Esc
 * and × only work before the countdown starts or after a failure (they mean Cancel / Close).
 */
@Component({
	selector: 'app-bulk-access-confirm-dialog',
	templateUrl: './bulk-access-confirm-dialog.component.html'
})
export class BulkAccessConfirmDialogComponent {
	@Input() visible = false;
	@Input() header = '';
	@Input() message = '';
	@Input() items: string[] = [];
	@Input() acceptLabel = 'Confirm';
	@Input() destructive = false;
	@Input() phase: BulkAccessConfirmPhase = 'confirm';
	/** False for a single row: no countdown, so sending looks like today's confirm (spinner on the button). */
	@Input() undoable = true;
	@Input() secondsLeft = 0;
	@Input() totalSeconds = 5;
	/** e.g. "Removing in 3s". */
	@Input() countdownNote = '';
	/** e.g. "Removing…". */
	@Input() sendingLabel = '';
	@Input() error = '';

	@Output() accept = new EventEmitter<void>();
	@Output() cancel = new EventEmitter<void>();
	@Output() undo = new EventEmitter<void>();
	@Output() retry = new EventEmitter<void>();

	get dismissable(): boolean {
		return this.phase === 'confirm' || this.phase === 'failed';
	}

	/** Countdown bar and "Removing…" button — only for a batch that went through the countdown. */
	get showCountdown(): boolean {
		return this.undoable && (this.phase === 'countdown' || this.phase === 'sending');
	}

	get progress(): number {
		return this.totalSeconds > 0 ? (this.secondsLeft / this.totalSeconds) * 100 : 0;
	}

	onVisibleChange(visible: boolean): void {
		if (!visible) this.cancel.emit();
	}
}
